import { POST_USER_SUCCESS } from 'stash/actions/api/user';
import { BOOTSTRAP_GET_ACCOUNTS_SUCCESS } from 'stash/store/bootstrapActions';
import { GET_ACCOUNTS_SUCCESS, POST_ACCOUNT_SUCCESS } from 'stash/actions/api/account';
import { ALLOWS_MULTIPLE_ACCOUNTS } from 'stash/constants/accountTypes';

type Account = {
	id: string;
	type: string;
};

type AccountByTypeState = Record<string, string | string[]>;

type Action = {
	type: string;
	response?: {
		accounts?: Account[];
		account?: Account;
	};
};

// Returns an array of account ids for a given account type if that account type
// supports multiple accounts. Otherwise, it returns a single id.
const getAccountIds = (account: Account, existingIndex: string[] = []): string | string[] => {
	if (account.type in ALLOWS_MULTIPLE_ACCOUNTS) {
		return [account.id, ...existingIndex];
	}

	return account.id;
};

const account_by_type = (state: AccountByTypeState = {}, action: Action): AccountByTypeState => {
	switch (action.type) {
		case POST_USER_SUCCESS:
		case BOOTSTRAP_GET_ACCOUNTS_SUCCESS:
			return (action.response?.accounts ?? []).reduce<AccountByTypeState>(
				(accountsByType, account) => {
					const existing = accountsByType[account.type];
					const existingArray = Array.isArray(existing)
						? existing
						: existing !== undefined
							? [existing]
							: [];
					accountsByType[account.type] = getAccountIds(account, existingArray);
					return accountsByType;
				},
				{}
			);

		case POST_ACCOUNT_SUCCESS: {
			const account = action.response?.account;
			if (!account) return state;

			const existing = state[account.type];
			const existingArray = Array.isArray(existing)
				? existing
				: existing !== undefined
					? [existing]
					: [];
			return {
				...state,
				[account.type]: getAccountIds(account, existingArray),
			};
		}

		case GET_ACCOUNTS_SUCCESS: {
			const accountsArr = action?.response?.accounts ?? [];
			return accountsArr.reduce<AccountByTypeState>((acc, curr) => {
				acc[curr.type] = curr.id;
				return acc;
			}, {});
		}

		default:
			return state;
	}
};

export default account_by_type;
